module.exports = __webpack_public_path__ + "static/media/safari-pinned-tab.b916fb84.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yieldlock-favicon/safari-pinned-tab.svg
// module id = 1444
// module chunks = 0